module.exports = __webpack_public_path__ + "img/full5-min.43165e2e.png";